<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :parentStoreNameTwo="parentStoreNameTwo"
    :parentUrlKeyTwo="parentUrlKeyTwo"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="is_available"
                rules="required"
                v-slot="{ errors }"
              >
                <v-checkbox
                  :error-messages="errors"
                  v-model="data.is_available"
                  label="Disponible"
                ></v-checkbox>
              </ValidationProvider>
            </v-col>

            <v-col>
              {{data.hour}}
              <ValidationProvider ref="hour" rules="required" v-slot="{ errors }">
                <v-menu
                    ref="hour"
                    v-model="menuHour"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                    :error-messages="errors"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="data.hour"
                        label="Hora"
                        prepend-icon="fas fa-clock"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      v-model="data.hour"
                      format="24hr"
                      @input="menuHour = false"
                  ></v-time-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({})
  },
  data() {
    return {
      storeName: "Availability_hours",
      title: "Hora disponible",
      parentStoreName: "professionals",
      parentUrlKey: "professional_id",
      parentStoreNameTwo: "Availability_days",
      parentUrlKeyTwo: "availability_day_id",
      show1: false,
      hour: null,
      menuHour: false,
      data: {
        hour: "",
        is_available: false,
        professional_id: "",
        availability_day_id:""
      }
    };
  },
  watch: {
    day(val) {
      this.day = val;
      this.data.day = this.formatDateForSave(val);
    }
  },
  created() {
    console.log(this.data);
    if (this.$route.params.professional_id)
      this.data.professional_id = this.$route.params.professional_id;
    if (this.$route.params.availability_day_id)
      this.data.availability_day_id = this.$route.params.availability_day_id;
  }
};
</script>
